import React, { Fragment } from 'react';
import { Box } from '@atlaskit/primitives';
import useButtonBase from '../shared/use-button-base';
import { contentStyles, getFadingStyles, iconStyles } from '../shared/xcss';
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */
const useDefaultButton = ({
  analyticsContext,
  appearance,
  autoFocus,
  buttonType,
  iconBefore,
  iconAfter,
  interactionName,
  isDisabled,
  isSelected,
  children,
  onClick,
  onMouseDownCapture,
  onMouseUpCapture,
  onKeyDownCapture,
  onKeyUpCapture,
  onTouchStartCapture,
  onTouchEndCapture,
  onPointerDownCapture,
  onPointerUpCapture,
  onClickCapture,
  overlay,
  ref,
  shouldFitContainer,
  spacing
}) => {
  const fadeStyles = getFadingStyles({
    hasOverlay: Boolean(overlay)
  });
  const baseProps = useButtonBase({
    analyticsContext,
    appearance,
    autoFocus,
    buttonType,
    children: /*#__PURE__*/React.createElement(Fragment, null, iconBefore && /*#__PURE__*/React.createElement(Box, {
      as: "span",
      xcss: [fadeStyles, iconStyles]
    }, iconBefore), children && /*#__PURE__*/React.createElement(Box, {
      as: "span",
      xcss: [fadeStyles, contentStyles]
    }, children), iconAfter && /*#__PURE__*/React.createElement(Box, {
      as: "span",
      xcss: [fadeStyles, iconStyles]
    }, iconAfter)),
    interactionName,
    isDisabled,
    isSelected,
    onClick,
    onMouseDownCapture,
    onMouseUpCapture,
    onKeyDownCapture,
    onKeyUpCapture,
    onTouchStartCapture,
    onTouchEndCapture,
    onPointerDownCapture,
    onPointerUpCapture,
    onClickCapture,
    overlay,
    ref,
    shouldFitContainer,
    spacing,
    hasIconBefore: Boolean(iconBefore),
    hasIconAfter: Boolean(iconAfter)
  });
  return baseProps;
};
export default useDefaultButton;